import React from "react";
import { Upload, Button, Tooltip } from "antd";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import styles from "./ImageUpload.module.scss";

const getBase64 = (file, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(file);
};

const ImagePreview = ({ value, onRemove }) =>
  value ? (
      <div className={styles.uploadedImageInner}>
        <img
          src={value}
          alt="uploaded"
          className={styles.uploadedImage}
        />
        <Tooltip title="Remove Image">
          <CloseOutlined
            className={styles.removeIcon}
            onClick={e => {
              e.stopPropagation();
              onRemove();
            }}
          />
        </Tooltip>
      </div>
  ) : null;

const ImageUpload = ({ value, onChange, label = "Upload Image", onRemove }) => (
  <React.Fragment>
    <Upload
      accept="image/*"
      showUploadList={false}
      style={{ width: "100%" }}
      beforeUpload={file => {
        getBase64(file, img => onChange(img));
        return false;
      }}
    >
      <Button className="standard-uploadbtn" icon={<UploadOutlined />}>
        {label}
      </Button>
    </Upload>
    <ImagePreview value={value} onRemove={onRemove} />
  </React.Fragment>
);

export default ImageUpload;
